<template xmlns="http://www.w3.org/1999/html">
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo-bottom.png" alt="logo图">
    </div>
    <p class="title">NS Petroleum</p>
    <p class="address_tel_fax">
      <span>Address: Room 2103, Futura Plaza, 111 How Ming Street, Kwun Tong, Hong Kong</span>
    </p>
    <p class="email_wx">
      <span>Email: Admin@nspetroleum.cn</span>
    </p>
    <p class="icp">版权所有：禾生石油有限公司</p>
    <p class="icp"></p>
    <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 桂ICP备2024018572号</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 80px;
  height: 80px;
  margin: 10px auto ;
}
.logo img {
  width: 100%;
  height: 100%;

}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx, .icp {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue